var isKind = require('./isKind');
    /**
     */
    function isNumber(val) {
        return isKind(val, 'Number');
    }
    module.exports = isNumber;




//////////////////
// WEBPACK FOOTER
// ./~/mout/lang/isNumber.js
// module id = 203
// module chunks = 0 1 2